import { Box, Image } from '@chakra-ui/react';
import kofiSymbol from '../../images/kofi-symbol.png';
import { KOFI_URL } from '../../constants/support';
import { BrandTooltip } from '../ui/tooltip';

/**
 * Compact Ko-fi mark for the header (next to profile). Uses official-style symbol artwork.
 */
export function SupportKofiHeaderIcon() {
  return (
    <BrandTooltip content="Support Riftbound DB" placement="bottom">
      <a
        href={KOFI_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Support Riftbound DB on Ko-fi"
        style={{ flexShrink: 0, textDecoration: 'none', display: 'inline-flex' }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          w={8}
          h={8}
          borderRadius="md"
          outline="none"
          transition="background 0.1s"
          _hover={{ bg: { base: 'blackAlpha.50', _dark: 'whiteAlpha.100' } }}
          _focusVisible={{
            outline: '2px solid',
            outlineColor: 'accent',
            outlineOffset: '2px',
          }}
        >
          <Image src={kofiSymbol} alt="" boxSize={{ base: '20px', sm: '22px' }} objectFit="contain" draggable={false} />
        </Box>
      </a>
    </BrandTooltip>
  );
}
